var company = {};
module['exports'] = company;
company.suffix = require("./suffix");
company.name = require("./name");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/nb_NO/company/index.js
 ** module id = 841
 ** module chunks = 0
 **/